import React from "react"
import Geonames from 'geonames.js';
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup"

import Logo from '../components/Logo.js'
import NavBar from '../components/NavBar.js'
import Footer from '../components/Footer.js'

import styled from 'styled-components'

const geonames = Geonames({
    username: 'hjamet',
    lan: 'fr',
    encoding: 'JSON'
  })

const Page = styled.div`
position:relative;
min-height:100vh;
overflow-y: scroll;
padding-bottom:300px;
`
const Title = styled.h2`
margin:0 auto;
`
const Champ = styled.div`
margin:10px auto;
padding: 0;
`

/*
* Un champ geonames est sauvegardé sous la forme :
* { continent: continent, pays: pays, uri: geonamesId, label: nom (adm1)}
* l'id geonames est discriminant mais pour la saisie on utilise les filtres
* continent, pays et affiche de la zone adm1
* autocomplétion s'effectue sur le nom (commence par) avec ajout de la zone adm1
*/
/*
const continents =[
    {code:'AF', name: 'Afrique'}
    , {code:'AS', name: 'Asie'}
    , {code:'EU', name: 'Europe'}
    , {code:'NA', name: 'Amérique du Nord'}
    , {code:'SA', name: 'Amérique du Sud'}
    , {code:'OC', name: 'Océanie'}
    , {code:'AN', name: 'Antartique'}
]
*/
const PageLogin = () => {

    const champVide = {
        geo:"",
    }


    const onSubmit = (elementCourant) => {
        //console.log("envoi formulaire")
        console.log("Je vais traiter ")
        console.log(elementCourant)
        //Continent / pays / région administrative si nb résultat
        //supérieur à 100

        //FeatureClass (A,H,L,P,R,S,T,U,V)
        // Ici A,P,L,S
        //les continents FeatureClass L FeatureCode CONT
        //les pays FeatureClass A FeatureCode PCLI je récupère le countryName et le countrycode

        geonames
        .search({
            name_startsWith: elementCourant.geo,
            country: "ES",
            featureClass: "P",
        })
        .then((reponse) => {
            console.log(reponse.totalResultsCount)
            for(const val of reponse.geonames){
                console.log(val.name + " (" + val.adminName1 + ")")
                console.log(val)
            }
        })
        .catch((erreur)=> {
            console.log("Probleme")
            console.log(erreur)
        })

    }

    const FormulaireJSX = () => {
        return(<Form>
            <Champ>
                <label>Champ géographique</label>
                <Field name="geo" type="text" size="20"/>
                <ErrorMessage name="geo" className="d-block invalid-feedback" component="span"/>
            </Champ>
            <button type="submit" onSubmit={onSubmit}>Traiter info</button>
            </Form>)
    }

    const validationSchema = Yup.object().shape({
        geo: Yup.string().required('Obligatoire'),
      })


    return (
        <Page>
            <Logo/>
            <NavBar/>
            <Title>Test GEO</Title>
            <Formik
                initialValues={champVide}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
                enableReinitialize={true}>
                <FormulaireJSX />
            </Formik>
            <Footer/>
        </Page>)
}
export default PageLogin